/**
 * engine API
 * engine API documentation
 *
 * OpenAPI spec version: 0.0.1
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */
/* tslint:disable:no-unused-variable member-ordering */
import {Inject, Injectable, Optional} from '@angular/core';
import {HttpClient, HttpEvent, HttpHeaders, HttpResponse} from '@angular/common/http';

import {Observable} from 'rxjs';


import {BASE_PATH} from '../variables';
import {Configuration} from '../configuration';
import {CallInvoices} from '../model/callInvoices';
import {CallInvoicesDTO} from '../model/callInvoicesDTO';
import {GetSmtpTemplateOverviewDTO} from '../model/getSmtpTemplateOverviewDTO';
import {SearchInvoicePrepareDataVO} from '../model/searchInvoicePrepareDataVO';
import {CallInvoiceScheduleSendRequest} from '../model/callInvoiceScheduleSendRequest';
import {InvoicePeriodPreview, InvoicePeriodPreviewRequest} from '../model/invoicePeriodPreview';
import {BookingStatusDTO} from '../model/bookingStatusDTO';

@Injectable()
export class EngineSearchInvoiceService {
    public listBookingStatuses(tenant: string): Observable<BookingStatusDTO[]> {
        return this.httpClient.get<BookingStatusDTO[]>(`${this.basePath}/api/booking-statuses`, {
            headers: this.defaultHeaders.set('X-DataStoreID', tenant), withCredentials: this.configuration.withCredentials
        });
    }

    public saveBookingStatus(tenant: string, status: BookingStatusDTO): Observable<BookingStatusDTO> {
        const options = {headers: this.defaultHeaders.set('X-DataStoreID', tenant), withCredentials: this.configuration.withCredentials};
        return status.id == null ? this.httpClient.post<BookingStatusDTO>(`${this.basePath}/api/booking-statuses`, status, options)
            : this.httpClient.put<BookingStatusDTO>(`${this.basePath}/api/booking-statuses/${status.id}`, status, options);
    }

    public deleteBookingStatus(tenant: string, id: number): Observable<void> {
        return this.httpClient.delete<void>(`${this.basePath}/api/booking-statuses/${id}`, {
            headers: this.defaultHeaders.set('X-DataStoreID', tenant), withCredentials: this.configuration.withCredentials
        });
    }

    public previewPeriods(body: InvoicePeriodPreviewRequest, xDataStoreID: string): Observable<InvoicePeriodPreview[]> {
        if (!body || !xDataStoreID) {
            throw new Error('Required parameters body and xDataStoreID when calling previewPeriods.');
        }
        return this.httpClient.post<InvoicePeriodPreview[]>(`${this.basePath}/api/invoice/preview-periods`, body, {
            headers: this.defaultHeaders.set('X-DataStoreID', xDataStoreID)
                .set('Accept', 'application/json').set('Content-Type', 'application/json'),
            withCredentials: this.configuration.withCredentials
        });
    }

    public downloadGenerationZip(tenant: string, callId: string, generationId: string, partner: string): Observable<HttpResponse<Blob>> {
        const path = [callId, generationId, partner].map(value => encodeURIComponent(value)).join('/');
        return this.httpClient.get(`${this.basePath}/api/invoice/download-zip/${path}`, {
            headers: this.defaultHeaders.set('X-DataStoreID', tenant), observe: 'response', responseType: 'blob',
            withCredentials: this.configuration.withCredentials
        });
    }

    protected basePath = 'https://dmp.airiane.com/services/engine';
    public defaultHeaders = new HttpHeaders();
    public configuration = new Configuration();

    constructor(protected httpClient: HttpClient, @Optional() @Inject(BASE_PATH) basePath: string, @Optional() configuration: Configuration) {
        if (basePath) {
            this.basePath = basePath;
        }
        if (configuration) {
            this.configuration = configuration;
            this.basePath = basePath || configuration.basePath || this.basePath;
        }
    }

    /**
     * @param consumes string[] mime-types
     * @return true: consumes contains 'multipart/form-data', false: otherwise
     */
    private canConsumeForm(consumes: string[]): boolean {
        const form = 'multipart/form-data';
        for (const consume of consumes) {
            if (form === consume) {
                return true;
            }
        }
        return false;
    }


    /**
     *
     *
     * @param xDataStoreID
     * @param idCallInvoices
     * @param idGeneration
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public deleteGeneration(xDataStoreID: string, idCallInvoices: string, idGeneration: string, observe?: 'body', reportProgress?: boolean): Observable<CallInvoices>;
    public deleteGeneration(xDataStoreID: string, idCallInvoices: string, idGeneration: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<CallInvoices>>;
    public deleteGeneration(xDataStoreID: string, idCallInvoices: string, idGeneration: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<CallInvoices>>;
    public deleteGeneration(xDataStoreID: string, idCallInvoices: string, idGeneration: string, observe: any = 'body', reportProgress = false): Observable<any> {

        if (xDataStoreID === null || xDataStoreID === undefined) {
            throw new Error('Required parameter xDataStoreID was null or undefined when calling deleteGeneration.');
        }

        if (idCallInvoices === null || idCallInvoices === undefined) {
            throw new Error('Required parameter idCallInvoices was null or undefined when calling deleteGeneration.');
        }

        if (idGeneration === null || idGeneration === undefined) {
            throw new Error('Required parameter idGeneration was null or undefined when calling deleteGeneration.');
        }

        let headers = this.defaultHeaders;
        if (xDataStoreID !== undefined && xDataStoreID !== null) {
            headers = headers.set('X-DataStoreID', String(xDataStoreID));
        }

        // to determine the Accept header
        const httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [];

        return this.httpClient.request<CallInvoices>('delete', `${this.basePath}/api/invoice/${encodeURIComponent(String(idCallInvoices))}/generations/${encodeURIComponent(String(idGeneration))}`,
            {
                withCredentials: this.configuration.withCredentials,
                headers,
                observe,
                reportProgress
            }
        );
    }

    /**
     *
     *
     * @param xDataStoreID
     * @param idCallInvoices
     * @param codePartner
     * @param command
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public downloadCsv(xDataStoreID: string, idCallInvoices: string, codePartner: string, command: string, observe?: 'body', reportProgress?: boolean): Observable<Blob>;
    public downloadCsv(xDataStoreID: string, idCallInvoices: string, codePartner: string, command: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Blob>>;
    public downloadCsv(xDataStoreID: string, idCallInvoices: string, codePartner: string, command: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Blob>>;
    public downloadCsv(xDataStoreID: string, idCallInvoices: string, codePartner: string, command: string, observe: any = 'body', reportProgress = false): Observable<any> {

        if (xDataStoreID === null || xDataStoreID === undefined) {
            throw new Error('Required parameter xDataStoreID was null or undefined when calling downloadCsv.');
        }

        if (idCallInvoices === null || idCallInvoices === undefined) {
            throw new Error('Required parameter idCallInvoices was null or undefined when calling downloadCsv.');
        }

        if (codePartner === null || codePartner === undefined) {
            throw new Error('Required parameter codePartner was null or undefined when calling downloadCsv.');
        }

        if (command === null || command === undefined) {
            throw new Error('Required parameter command was null or undefined when calling downloadCsv.');
        }

        let headers = this.defaultHeaders;
        if (xDataStoreID !== undefined && xDataStoreID !== null) {
            headers = headers.set('X-DataStoreID', String(xDataStoreID));
        }

        // to determine the Accept header
        const httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [];

        return this.httpClient.request<Blob>('get', `${this.basePath}/api/invoice/download/${encodeURIComponent(String(idCallInvoices))}/${encodeURIComponent(String(codePartner))}/${encodeURIComponent(String(command))}`,
            {
                withCredentials: this.configuration.withCredentials,
                headers,
                observe,
                reportProgress
            }
        );
    }

    /**
     *
     *
     * @param xDataStoreID
     * @param idCallInvoices
     * @param idGeneration
     * @param codePartner
     * @param idExcelFile
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public downloadExcel(xDataStoreID: string, idCallInvoices: string, idGeneration: string, codePartner: string, idExcelFile: string, observe?: 'body', reportProgress?: boolean): Observable<any>;
    public downloadExcel(xDataStoreID: string, idCallInvoices: string, idGeneration: string, codePartner: string, idExcelFile: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<any>>;
    public downloadExcel(xDataStoreID: string, idCallInvoices: string, idGeneration: string, codePartner: string, idExcelFile: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<any>>;
    public downloadExcel(xDataStoreID: string, idCallInvoices: string, idGeneration: string, codePartner: string, idExcelFile: string, observe: any = 'body', reportProgress = false): Observable<any> {

        if (xDataStoreID === null || xDataStoreID === undefined) {
            throw new Error('Required parameter xDataStoreID was null or undefined when calling downloadExcel.');
        }

        if (idCallInvoices === null || idCallInvoices === undefined) {
            throw new Error('Required parameter idCallInvoices was null or undefined when calling downloadExcel.');
        }

        if (idGeneration === null || idGeneration === undefined) {
            throw new Error('Required parameter idGeneration was null or undefined when calling downloadExcel.');
        }

        if (codePartner === null || codePartner === undefined) {
            throw new Error('Required parameter codePartner was null or undefined when calling downloadExcel.');
        }

        if (idExcelFile === null || idExcelFile === undefined) {
            throw new Error('Required parameter idExcelFile was null or undefined when calling downloadExcel.');
        }

        let headers = this.defaultHeaders;
        if (xDataStoreID !== undefined && xDataStoreID !== null) {
            headers = headers.set('X-DataStoreID', String(xDataStoreID));
        }

        // to determine the Accept header
        const httpHeaderAccepts: string[] = [
            'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [];

        return this.httpClient.request<any>('get', `${this.basePath}/api/invoice/download-excel/${encodeURIComponent(String(idCallInvoices))}/${encodeURIComponent(String(idGeneration))}/${encodeURIComponent(String(codePartner))}/${encodeURIComponent(String(idExcelFile))}`,
            {
                responseType: 'blob' as 'json',
                withCredentials: this.configuration.withCredentials,
                headers,
                observe,
                reportProgress
            }
        );
    }

    /**
     *
     *
     * @param xDataStoreID
     * @param idCallInvoices
     * @param codePartner
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public downloadPdf(xDataStoreID: string, idCallInvoices: string, codePartner: string, observe?: 'body', reportProgress?: boolean): Observable<any>;
    public downloadPdf(xDataStoreID: string, idCallInvoices: string, codePartner: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<any>>;
    public downloadPdf(xDataStoreID: string, idCallInvoices: string, codePartner: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<any>>;
    public downloadPdf(xDataStoreID: string, idCallInvoices: string, codePartner: string, observe: any = 'body', reportProgress = false): Observable<any> {

        if (xDataStoreID === null || xDataStoreID === undefined) {
            throw new Error('Required parameter xDataStoreID was null or undefined when calling downloadPdf.');
        }

        if (idCallInvoices === null || idCallInvoices === undefined) {
            throw new Error('Required parameter idCallInvoices was null or undefined when calling downloadPdf.');
        }

        if (codePartner === null || codePartner === undefined) {
            throw new Error('Required parameter codePartner was null or undefined when calling downloadPdf.');
        }

        let headers = this.defaultHeaders;
        if (xDataStoreID !== undefined && xDataStoreID !== null) {
            headers = headers.set('X-DataStoreID', String(xDataStoreID));
        }

        // to determine the Accept header
        const httpHeaderAccepts: string[] = [
            'application/pdf'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [];

        return this.httpClient.request<any>('get', `${this.basePath}/api/invoice/download-pdf/${encodeURIComponent(String(idCallInvoices))}/${encodeURIComponent(String(codePartner))}`,
            {
                responseType: 'blob' as 'json',
                withCredentials: this.configuration.withCredentials,
                headers,
                observe,
                reportProgress
            }
        );
    }

    /**
     *
     *
     * @param xDataStoreID
     * @param idCallInvoices
     * @param idGeneration
     * @param codePartner
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public downloadPdfByGeneration(xDataStoreID: string, idCallInvoices: string, idGeneration: string, codePartner: string, observe?: 'body', reportProgress?: boolean): Observable<any>;
    public downloadPdfByGeneration(xDataStoreID: string, idCallInvoices: string, idGeneration: string, codePartner: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<any>>;
    public downloadPdfByGeneration(xDataStoreID: string, idCallInvoices: string, idGeneration: string, codePartner: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<any>>;
    public downloadPdfByGeneration(xDataStoreID: string, idCallInvoices: string, idGeneration: string, codePartner: string, observe: any = 'body', reportProgress = false): Observable<any> {

        if (xDataStoreID === null || xDataStoreID === undefined) {
            throw new Error('Required parameter xDataStoreID was null or undefined when calling downloadPdfByGeneration.');
        }

        if (idCallInvoices === null || idCallInvoices === undefined) {
            throw new Error('Required parameter idCallInvoices was null or undefined when calling downloadPdfByGeneration.');
        }

        if (idGeneration === null || idGeneration === undefined) {
            throw new Error('Required parameter idGeneration was null or undefined when calling downloadPdfByGeneration.');
        }

        if (codePartner === null || codePartner === undefined) {
            throw new Error('Required parameter codePartner was null or undefined when calling downloadPdfByGeneration.');
        }

        let headers = this.defaultHeaders;
        if (xDataStoreID !== undefined && xDataStoreID !== null) {
            headers = headers.set('X-DataStoreID', String(xDataStoreID));
        }

        // to determine the Accept header
        const httpHeaderAccepts: string[] = [
            'application/pdf'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [];

        return this.httpClient.request<any>('get', `${this.basePath}/api/invoice/download-pdf/${encodeURIComponent(String(idCallInvoices))}/${encodeURIComponent(String(idGeneration))}/${encodeURIComponent(String(codePartner))}`,
            {
                responseType: 'blob' as 'json',
                withCredentials: this.configuration.withCredentials,
                headers,
                observe,
                reportProgress
            }
        );
    }

    /**
     *
     *
     * @param body
     * @param xDataStoreID
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public prepareData(body: SearchInvoicePrepareDataVO, xDataStoreID: string, observe?: 'body', reportProgress?: boolean): Observable<CallInvoicesDTO>;
    public prepareData(body: SearchInvoicePrepareDataVO, xDataStoreID: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<CallInvoicesDTO>>;
    public prepareData(body: SearchInvoicePrepareDataVO, xDataStoreID: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<CallInvoicesDTO>>;
    public prepareData(body: SearchInvoicePrepareDataVO, xDataStoreID: string, observe: any = 'body', reportProgress = false): Observable<any> {

        if (body === null || body === undefined) {
            throw new Error('Required parameter body was null or undefined when calling prepareData.');
        }

        if (xDataStoreID === null || xDataStoreID === undefined) {
            throw new Error('Required parameter xDataStoreID was null or undefined when calling prepareData.');
        }

        let headers = this.defaultHeaders;
        if (xDataStoreID !== undefined && xDataStoreID !== null) {
            headers = headers.set('X-DataStoreID', String(xDataStoreID));
        }

        // to determine the Accept header
        const httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.request<CallInvoicesDTO>('post', `${this.basePath}/api/invoice/prepare-data`,
            {
                body,
                withCredentials: this.configuration.withCredentials,
                headers,
                observe,
                reportProgress
            }
        );
    }

    /**
     *
     *
     * @param xDataStoreID
     * @param idCallInvoices
     * @param codePartner
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public previewEmail(xDataStoreID: string, idCallInvoices: string, codePartner: string, observe?: 'body', reportProgress?: boolean): Observable<GetSmtpTemplateOverviewDTO>;
    public previewEmail(xDataStoreID: string, idCallInvoices: string, codePartner: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<GetSmtpTemplateOverviewDTO>>;
    public previewEmail(xDataStoreID: string, idCallInvoices: string, codePartner: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<GetSmtpTemplateOverviewDTO>>;
    public previewEmail(xDataStoreID: string, idCallInvoices: string, codePartner: string, observe: any = 'body', reportProgress = false): Observable<any> {

        if (xDataStoreID === null || xDataStoreID === undefined) {
            throw new Error('Required parameter xDataStoreID was null or undefined when calling previewEmail.');
        }

        if (idCallInvoices === null || idCallInvoices === undefined) {
            throw new Error('Required parameter idCallInvoices was null or undefined when calling previewEmail.');
        }

        if (codePartner === null || codePartner === undefined) {
            throw new Error('Required parameter codePartner was null or undefined when calling previewEmail.');
        }

        let headers = this.defaultHeaders;
        if (xDataStoreID !== undefined && xDataStoreID !== null) {
            headers = headers.set('X-DataStoreID', String(xDataStoreID));
        }

        // to determine the Accept header
        const httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [];

        return this.httpClient.request<GetSmtpTemplateOverviewDTO>('get', `${this.basePath}/api/invoice/preview-email/${encodeURIComponent(String(idCallInvoices))}/${encodeURIComponent(String(codePartner))}`,
            {
                withCredentials: this.configuration.withCredentials,
                headers,
                observe,
                reportProgress
            }
        );
    }

    /**
     *
     *
     * @param xDataStoreID
     * @param idCallInvoices
     * @param idGeneration
     * @param codePartner
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public previewEmailByGeneration(xDataStoreID: string, idCallInvoices: string, idGeneration: string, codePartner: string, observe?: 'body', reportProgress?: boolean): Observable<GetSmtpTemplateOverviewDTO>;
    public previewEmailByGeneration(xDataStoreID: string, idCallInvoices: string, idGeneration: string, codePartner: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<GetSmtpTemplateOverviewDTO>>;
    public previewEmailByGeneration(xDataStoreID: string, idCallInvoices: string, idGeneration: string, codePartner: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<GetSmtpTemplateOverviewDTO>>;
    public previewEmailByGeneration(xDataStoreID: string, idCallInvoices: string, idGeneration: string, codePartner: string, observe: any = 'body', reportProgress = false): Observable<any> {

        if (xDataStoreID === null || xDataStoreID === undefined) {
            throw new Error('Required parameter xDataStoreID was null or undefined when calling previewEmailByGeneration.');
        }

        if (idCallInvoices === null || idCallInvoices === undefined) {
            throw new Error('Required parameter idCallInvoices was null or undefined when calling previewEmailByGeneration.');
        }

        if (idGeneration === null || idGeneration === undefined) {
            throw new Error('Required parameter idGeneration was null or undefined when calling previewEmailByGeneration.');
        }

        if (codePartner === null || codePartner === undefined) {
            throw new Error('Required parameter codePartner was null or undefined when calling previewEmailByGeneration.');
        }

        let headers = this.defaultHeaders;
        if (xDataStoreID !== undefined && xDataStoreID !== null) {
            headers = headers.set('X-DataStoreID', String(xDataStoreID));
        }

        // to determine the Accept header
        const httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [];

        return this.httpClient.request<GetSmtpTemplateOverviewDTO>('get', `${this.basePath}/api/invoice/preview-email/${encodeURIComponent(String(idCallInvoices))}/${encodeURIComponent(String(idGeneration))}/${encodeURIComponent(String(codePartner))}`,
            {
                withCredentials: this.configuration.withCredentials,
                headers,
                observe,
                reportProgress
            }
        );
    }

    /**
     *
     *
     * @param xDataStoreID
     * @param idCallInvoices
     * @param codePartner
     * @param email
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public sendTestEmail1(xDataStoreID: string, idCallInvoices: string, codePartner: string, email: string, observe?: 'body', reportProgress?: boolean): Observable<any>;
    public sendTestEmail1(xDataStoreID: string, idCallInvoices: string, codePartner: string, email: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<any>>;
    public sendTestEmail1(xDataStoreID: string, idCallInvoices: string, codePartner: string, email: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<any>>;
    public sendTestEmail1(xDataStoreID: string, idCallInvoices: string, codePartner: string, email: string, observe: any = 'body', reportProgress = false): Observable<any> {

        if (xDataStoreID === null || xDataStoreID === undefined) {
            throw new Error('Required parameter xDataStoreID was null or undefined when calling sendTestEmail1.');
        }

        if (idCallInvoices === null || idCallInvoices === undefined) {
            throw new Error('Required parameter idCallInvoices was null or undefined when calling sendTestEmail1.');
        }

        if (codePartner === null || codePartner === undefined) {
            throw new Error('Required parameter codePartner was null or undefined when calling sendTestEmail1.');
        }

        if (email === null || email === undefined) {
            throw new Error('Required parameter email was null or undefined when calling sendTestEmail1.');
        }

        let headers = this.defaultHeaders;
        if (xDataStoreID !== undefined && xDataStoreID !== null) {
            headers = headers.set('X-DataStoreID', String(xDataStoreID));
        }

        // to determine the Accept header
        const httpHeaderAccepts: string[] = [];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [];

        return this.httpClient.request<any>('get', `${this.basePath}/api/invoice/send-test-email/${encodeURIComponent(String(idCallInvoices))}/${encodeURIComponent(String(codePartner))}/${encodeURIComponent(String(email))}`,
            {
                withCredentials: this.configuration.withCredentials,
                headers,
                observe,
                reportProgress
            }
        );
    }
    /** Send a test using the same affiliate snapshot as the selected generation preview. */
    public sendTestEmailByGeneration(xDataStoreID: string, idCallInvoices: string, idGeneration: string, codePartner: string, email: string, observe?: 'body', reportProgress?: boolean): Observable<any>;
    public sendTestEmailByGeneration(xDataStoreID: string, idCallInvoices: string, idGeneration: string, codePartner: string, email: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<any>>;
    public sendTestEmailByGeneration(xDataStoreID: string, idCallInvoices: string, idGeneration: string, codePartner: string, email: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<any>>;
    public sendTestEmailByGeneration(xDataStoreID: string, idCallInvoices: string, idGeneration: string, codePartner: string, email: string, observe: any = 'body', reportProgress = false): Observable<any> {

        if (xDataStoreID === null || xDataStoreID === undefined) {
            throw new Error('Required parameter xDataStoreID was null or undefined when calling sendTestEmailByGeneration.');
        }

        if (idCallInvoices === null || idCallInvoices === undefined) {
            throw new Error('Required parameter idCallInvoices was null or undefined when calling sendTestEmailByGeneration.');
        }

        if (idGeneration === null || idGeneration === undefined) {
            throw new Error('Required parameter idGeneration was null or undefined when calling sendTestEmailByGeneration.');
        }

        if (codePartner === null || codePartner === undefined) {
            throw new Error('Required parameter codePartner was null or undefined when calling sendTestEmailByGeneration.');
        }

        if (email === null || email === undefined) {
            throw new Error('Required parameter email was null or undefined when calling sendTestEmailByGeneration.');
        }

        let headers = this.defaultHeaders;
        if (xDataStoreID !== undefined && xDataStoreID !== null) {
            headers = headers.set('X-DataStoreID', String(xDataStoreID));
        }

        // to determine the Accept header
        const httpHeaderAccepts: string[] = [];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [];

        return this.httpClient.request<any>('get', `${this.basePath}/api/invoice/send-test-email/${encodeURIComponent(String(idCallInvoices))}/${encodeURIComponent(String(idGeneration))}/${encodeURIComponent(String(codePartner))}/${encodeURIComponent(String(email))}`,
            {
                withCredentials: this.configuration.withCredentials,
                headers,
                observe,
                reportProgress
            }
        );
    }

    /**
     *
     *
     * @param xDataStoreID
     * @param idCallInvoices
     * @param idGeneration
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public validateGeneration(xDataStoreID: string, idCallInvoices: string, idGeneration: string, observe?: 'body', reportProgress?: boolean): Observable<CallInvoices>;
    public validateGeneration(xDataStoreID: string, idCallInvoices: string, idGeneration: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<CallInvoices>>;
    public validateGeneration(xDataStoreID: string, idCallInvoices: string, idGeneration: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<CallInvoices>>;
    public validateGeneration(xDataStoreID: string, idCallInvoices: string, idGeneration: string, observe: any = 'body', reportProgress = false): Observable<any> {

        if (xDataStoreID === null || xDataStoreID === undefined) {
            throw new Error('Required parameter xDataStoreID was null or undefined when calling validateGeneration.');
        }

        if (idCallInvoices === null || idCallInvoices === undefined) {
            throw new Error('Required parameter idCallInvoices was null or undefined when calling validateGeneration.');
        }

        if (idGeneration === null || idGeneration === undefined) {
            throw new Error('Required parameter idGeneration was null or undefined when calling validateGeneration.');
        }

        let headers = this.defaultHeaders;
        if (xDataStoreID !== undefined && xDataStoreID !== null) {
            headers = headers.set('X-DataStoreID', String(xDataStoreID));
        }

        // to determine the Accept header
        const httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [];

        return this.httpClient.request<CallInvoices>('put', `${this.basePath}/api/invoice/${encodeURIComponent(String(idCallInvoices))}/generations/${encodeURIComponent(String(idGeneration))}/validate`,
            {
                withCredentials: this.configuration.withCredentials,
                headers,
                observe,
                reportProgress
            }
        );
    }

    /**
     *
     *
     * @param xDataStoreID
     * @param idCallInvoices
     * @param idGeneration
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public sendGenerationEmails(xDataStoreID: string, idCallInvoices: string, idGeneration: string, observe?: 'body', reportProgress?: boolean): Observable<any>;
    public sendGenerationEmails(xDataStoreID: string, idCallInvoices: string, idGeneration: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<any>>;
    public sendGenerationEmails(xDataStoreID: string, idCallInvoices: string, idGeneration: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<any>>;
    public sendGenerationEmails(xDataStoreID: string, idCallInvoices: string, idGeneration: string, observe: any = 'body', reportProgress = false): Observable<any> {

        if (xDataStoreID === null || xDataStoreID === undefined) {
            throw new Error('Required parameter xDataStoreID was null or undefined when calling sendGenerationEmails.');
        }

        if (idCallInvoices === null || idCallInvoices === undefined) {
            throw new Error('Required parameter idCallInvoices was null or undefined when calling sendGenerationEmails.');
        }

        if (idGeneration === null || idGeneration === undefined) {
            throw new Error('Required parameter idGeneration was null or undefined when calling sendGenerationEmails.');
        }

        let headers = this.defaultHeaders;
        if (xDataStoreID !== undefined && xDataStoreID !== null) {
            headers = headers.set('X-DataStoreID', String(xDataStoreID));
        }

        // to determine the Accept header
        const httpHeaderAccepts: string[] = [];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [];

        return this.httpClient.request<any>('post', `${this.basePath}/api/invoice/${encodeURIComponent(String(idCallInvoices))}/generations/${encodeURIComponent(String(idGeneration))}/send-emails`,
            {
                withCredentials: this.configuration.withCredentials,
                headers,
                observe,
                reportProgress
            }
        );
    }

    /**
     *
     *
     * @param body
     * @param xDataStoreID
     * @param idCallInvoices
     * @param idGeneration
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public scheduleSendGeneration(body: CallInvoiceScheduleSendRequest, xDataStoreID: string, idCallInvoices: string, idGeneration: string, observe?: 'body', reportProgress?: boolean): Observable<CallInvoices>;
    public scheduleSendGeneration(body: CallInvoiceScheduleSendRequest, xDataStoreID: string, idCallInvoices: string, idGeneration: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<CallInvoices>>;
    public scheduleSendGeneration(body: CallInvoiceScheduleSendRequest, xDataStoreID: string, idCallInvoices: string, idGeneration: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<CallInvoices>>;
    public scheduleSendGeneration(body: CallInvoiceScheduleSendRequest, xDataStoreID: string, idCallInvoices: string, idGeneration: string, observe: any = 'body', reportProgress = false): Observable<any> {

        if (body === null || body === undefined) {
            throw new Error('Required parameter body was null or undefined when calling scheduleSendGeneration.');
        }

        if (xDataStoreID === null || xDataStoreID === undefined) {
            throw new Error('Required parameter xDataStoreID was null or undefined when calling scheduleSendGeneration.');
        }

        if (idCallInvoices === null || idCallInvoices === undefined) {
            throw new Error('Required parameter idCallInvoices was null or undefined when calling scheduleSendGeneration.');
        }

        if (idGeneration === null || idGeneration === undefined) {
            throw new Error('Required parameter idGeneration was null or undefined when calling scheduleSendGeneration.');
        }

        let headers = this.defaultHeaders;
        if (xDataStoreID !== undefined && xDataStoreID !== null) {
            headers = headers.set('X-DataStoreID', String(xDataStoreID));
        }

        // to determine the Accept header
        const httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.request<CallInvoices>('put', `${this.basePath}/api/invoice/${encodeURIComponent(String(idCallInvoices))}/generations/${encodeURIComponent(String(idGeneration))}/schedule-send`,
            {
                body,
                withCredentials: this.configuration.withCredentials,
                headers,
                observe,
                reportProgress
            }
        );
    }

}
